import React from 'react';

import { AdditionalInfoChipRoot } from '../styles';

type AdditionalInfoChipProps = {
  /** `success` once the count is complete, `primary` while it is not. */
  tone: 'success' | 'primary';
  label: string;
};

/**
 * The count the collection shows: filled groups in the accordion, unit in the modal. It
 * looks like the chip payments draws, and that is a coincidence of the design — each side
 * owns its own so a change to one does not reach the other.
 */
export const AdditionalInfoChip = (props: AdditionalInfoChipProps) => {
  const { tone, label } = props;

  return <AdditionalInfoChipRoot data-testid='additional-info-chip' data-tone={tone} label={label} size='small' />;
};

export default AdditionalInfoChip;
